import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import { UiTopBgSlider, UiTopBgSliderLeftContent, UiInnerTopBgSlider } from "../../components/common/UiTopBgSliderElements"
// import SliderHeart from "../../../../../styles/img/slider-heart-icon.png";
// import UiInnerTopSliderCard from "../../../components/common/UiInnerTopSliderCard"
// import { UiSliderImageCard } from '../../../components/common/UiSliderImageCard';
// import { Button, Table } from "react-bootstrap";

export default function CommsTopBanner(props) {

    return (
        <>
            <UiInnerTopBgSlider>
                <UiTopBgSlider>
                    <UiCol lg="5" className="sb-comms-top-banner">
                        <UiTopBgSliderLeftContent>
                          <h3>Introducing XC90 Recharge</h3>
                          <p>lorem epsum text dandom text  Volvo Accessories per sale lorem epsum text dandom text  Volvo Accessories</p> 
                        </ UiTopBgSliderLeftContent>
                    </UiCol>
                    <UiCol lg="7" className="mt-3 sb-comms-video">
                    <video width="100%" controls>
                        <source src="mov_bbb.mp4" type="video/mp4"/>
                    </video>
                    </UiCol>

                </UiTopBgSlider>
            </UiInnerTopBgSlider>
        </>
    )
}
